import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/admins/sidebar.css";
import { useNavigate } from "react-router-dom";
import logo from "../../images/logo.png";

function ClientSidebar({ isAdmin }) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    setIsCollapsed(false);
  };

  const handleMouseLeave = () => {
    setIsCollapsed(true);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  return (
    <div
      className={`sidebar ${isCollapsed ? "collapsed" : ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ul className="sidebar-menu">
        <div className="side-logo-container">
          {/* <img
            src={logo}
            className={`side-logo ${isCollapsed ? "collapsed" : ""}`}
            alt="logo"
          /> */}
          <img
            src={logo}
style={{
  display: isCollapsed ? "none" : "block",
  height: isCollapsed ? undefined : "2em"
}}
/>
        </div>
        <NavLink to="/client/dashboard">
          <i className="bx bxs-home-smile"></i>
          <li>Dashboard</li>
        </NavLink>
        <br />
        <NavLink to="/client/product">
          <i className="bx bxs-customize"></i>
          <li>Raise Ticket</li>
        </NavLink>
        <br />
        <NavLink to="/client/profile">
          <i className="bx bxs-user-circle"></i>
          <li>My Profile</li>
        </NavLink>
        <br />
        <NavLink to="/client/tickets">
          <i className="bx bxs-purchase-tag-alt"></i>
          <li>View Tickets</li>
        </NavLink>
        {isAdmin && (
          <>
            <br />
            <NavLink to="/client/users">
              <i className="bx bxs-user"></i>
              <li>View Users</li>
            </NavLink>
            <br />
            <NavLink to="/client/reports">
              <i className="bx bxs-bar-chart-alt-2"></i>
              <li>View Report</li>
            </NavLink>
          </>
        )}
        <br />
        <NavLink to="/admin/logout" onClick={handleLogout}>
          <i className="bx bx-log-out-circle"></i>
          <li>Logout</li>
        </NavLink>
      </ul>
    </div>
  );
}

export default ClientSidebar;
